// extracted by mini-css-extract-plugin
export default {"trigger":"_39qe"};